import _mock from "../_mock";

export const _PackageList = [...Array(24)].map((_, index) => ({
    Package_name: 'Package Name',
    Package_info: "Increase orders by up to 40%",
    Package_cost: _mock.number.age(index) * 2,
    Package_duration: '7 Days',
    start_at: '20 Jun 2022 ',
    end_at: '27 Jun 2022 ',
}));


export const _OffersList = [...Array(24)].map((_, index) => ({
    offer_name: 'Family Box',
    discount: "20 %",
    offers_items: _mock.id(index),
    start_at: '20 Jun 2022',
    end_at: '27 Jun 2022',
}));

